import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { BaseUser } from '@abaco/web-common/src/BaseUser';
import { ChangeRequest } from "./models/ChangeRequest";
import { ProjectProposal } from "./models/ProjectProposal";
import { ClosureContract, ProgressContract } from "./models/Contract";
import { ContextFunctions } from './models/FunctionResponse';
import { PrivacyResponse } from "./models/Privacy";
import { Subject } from "./models/Subject";

export default class MaltaCustomerPortalVuexModule extends AbacoVuexModule
{
    @State() user!: BaseUser | null;
    @State() userFunctions!: ContextFunctions | null;
    @State({ default: [] }) privacyChecks!: PrivacyResponse[];
    @State({ default: true }) isSignleSubject!: boolean;
    @State({ default: null }) currentSubject!: Subject | null;
    @State({ default: null }) currentContract!: ClosureContract | ProgressContract | ChangeRequest | ProjectProposal | null;
}
